import { notification } from 'antd';
import { useMutation } from 'react-query';
import { generateKitsReport } from './Report.service';
import notificationError from '@/utils/functions/notificationError';

export function useGenerateKitsReport() {
  return useMutation(generateKitsReport, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Relatório de Kits gerado.',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
